import * as React from 'react';
export const IcDigitalEcosystem = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14.5 19a1.51 1.51 0 00-1.38.91c-.37.06-.745.09-1.12.09A8 8 0 015.8 7H6a1.5 1.5 0 10-1.49-1.6 10 10 0 009.3 16.43 1.6 1.6 0 00.69.17 1.51 1.51 0 001.5-1.45v-.05a1.5 1.5 0 00-1.5-1.5zm-5-14a1.51 1.51 0 001.38-.9 7.82 7.82 0 015.63 1.31v.09A1.5 1.5 0 1018 4a9.9 9.9 0 00-7.76-1.82A1.53 1.53 0 009.5 2a1.5 1.5 0 100 3zm12.33 5.19c.108-.214.166-.45.17-.69A1.51 1.51 0 0020.55 8h-.05a1.5 1.5 0 00-.59 2.88c.06.37.09.745.09 1.12a8 8 0 01-1.8 5 1.5 1.5 0 101.8 1.5 1.55 1.55 0 00-.07-.43 9.888 9.888 0 001.9-7.88zM12 10a2 2 0 100 4 2 2 0 000-4zm6.5 1.5a1.5 1.5 0 10-2.56 1.06 4 4 0 11-4.5-4.5 1.51 1.51 0 10-.08-2 6 6 0 106.6 6.6 1.48 1.48 0 00.54-1.16z'
      fill='currentColor'
    />
  </svg>
);
